import { Injectable, Output, EventEmitter, Inject } from '@angular/core';
import 'rxjs/add/operator/map';
import { ApiService } from './api.service';
import { Observable, Subscription } from 'rxjs';
import * as moment from 'moment';
import DateTimeUtil from 'app/utils/datatime';
import { SalesManager } from './sales/model/SalesManager';
import { utils } from 'xlsx';
import { Util } from 'app/utils';

// declare var moment:any;

@Injectable()
export class SalesService {

  constructor(private apiService: ApiService) { }

  getSaleManagers(callback: (value: SalesManager[]) => void): Subscription {

    return this.apiService.getInnerTargetApi('user/sales/manager', null, callback);
  }

  private objectToUserForSalesManagementPage(obj: Object): PageModel<UserForSalesManagement> {

    let result = new PageModel<UserForSalesManagement>(obj);
    if (obj['datas'] && Array.isArray(obj['datas'])) {
      result.datas = [];
      for (let data of obj['datas']) {
        result.datas.push(new UserForSalesManagement(data));
      }
    }

    return result;
  }

  getUsers(getUserParameter: GetUserParameter, callback?: (value: PageModel<UserForSalesManagement>) => void): Subscription {
    let url: string = "user/sales";

    let query: string = null;
    if (getUserParameter) {
      query = "?page=" + getUserParameter.page;

      if (getUserParameter.jobTp) {
        query += "&jobTp=" + getUserParameter.jobTp;
      }

      if (getUserParameter.stusCd !== null && typeof getUserParameter.stusCd !== 'undefined') {
        query += "&stusCd=" + getUserParameter.stusCd;
      }

      if (getUserParameter.salesManagerUserId !== null && typeof getUserParameter.salesManagerUserId !== 'undefined') {
        query += "&salesManagerUserId=" + getUserParameter.salesManagerUserId;
      }

      if (getUserParameter.lingoAuthStatusCd !== null && typeof getUserParameter.lingoAuthStatusCd !== 'undefined') {
        query += "&lingoAuthStatusCd=" + getUserParameter.lingoAuthStatusCd;
      }

      if (getUserParameter.text) {
        query += "&text=" + getUserParameter.text;
      }

    }

    if (query) {
      url += query;
    }


    return this.apiService.getInnerTargetApi(url, null, (value: Object) => { if (callback) callback(this.objectToUserForSalesManagementPage(value)) });
  }



  getUser(userId: number, callback?: (value: UserForSalesManagement) => void): Subscription {
    let url: string = "user/sales/individual?userId=" + userId;

    return this.apiService.getInnerTargetApi(
      url,
      null,
      (value: Object) => {
        let user = new UserForSalesManagement(value);
        if (callback) {
          callback(user);
        }
      }
    );
  }


  public getUserAuth(userId: number, callback?: (value: UserAuth) => void): Subscription {
    let url: string = "userauth/" + new String(userId);
    return this.apiService.getInnerTargetApi(url, null, (value: Object) => { if (callback) callback(new UserAuth(value)); });
  }

  public patchUser(userId: number, modifiedValues: any, callback?) {
    if (userId === null || typeof userId === 'undefined') {
      return;
    }
    let url: string = "user/" + (new String(userId));
    return this.apiService.patchInnerTargetApi(url, modifiedValues, (value: Object) => { if (callback) callback(); });
  }

  public patchUserAuth(userAuthId: number, modifiedValues: any, callback?) {
    if (userAuthId === null || typeof userAuthId === 'undefined') {
      return
    }
    let url: string = "userauth/" + (new String(userAuthId));
    return this.apiService.patchInnerTargetApi(url, modifiedValues, (value: Object) => { if (callback) callback(); });
  }

  public getUserSalesMessages(userId: number, callback?: (values: UserSalesMessage[]) => void) {
    let url: string = "user/sales/message/" + new String(userId);

    return this.apiService.getInnerTargetApi(url, null, (values: Object[]) => {
      if (!values) {
        return
      }

      if (callback) {
        let messages: UserSalesMessage[] = [];
        let session = JSON.parse(localStorage.getItem('currentUser'));

        for (let value of values) {
          value['sessionUserId'] = session.id;
          messages.push(new UserSalesMessage(value));
        }

        callback(messages);
      }
    });

  }


  postMessage(userId: number, message: string, callback: () => void, errorCallback: (error: any) => void) {
    let url: string = "user/sales/message";

    return this.apiService.postInnerTargetApi(
      url,
      { userId: userId, message: message },
      (value: any) => {
        callback();
      },
      (error: any) => {
        errorCallback(error);
      }
    );
  }

  deleteMessage(messageId: number, callback: () => void, errorCallback: (error: any) => void) {
    let url: string = "user/sales/message";

    return this.apiService.delInnerTargetApi(
      url,
      { messageId: messageId },
      (value: any) => {
        callback();
      },
      (error: any) => {
        errorCallback(error);
      }
    );

  }

  putMessage(messageId: number, message: String, callback: () => void, errorCallback: (error: any) => void) {
    let url: string = "user/sales/message";

    return this.apiService.putInnerTargetApi(
      url,
      { messageId: messageId, message: message },
      (value: any) => {
        callback();
      },
      (error: any) => {
        errorCallback(error);
      }
    );
  }

  putUserSalesStatus(userId: number, salesStatusCode: String, salesManagerUserId: number, callback: () => void, errorCallback: (error: any) => void) {
    let url = 'user/sales/status/' + String(userId);
    return this.apiService.putInnerTargetApi(
      url,
      { salesStatusCode: salesStatusCode, salesManagerUserId: salesManagerUserId },
      (value: any) => {
        callback();
      },
      (error: any) => {
        errorCallback(error);
      }
    );
  }

  deleteUserSalesStatus(userId: number, callback: () => void, errorCallback: (error: any) => void) {
    let url = 'user/sales/status/' + String(userId);
    return this.apiService.delInnerTargetApi(
      url,
      null,
      (value: any) => {
        callback();
      },
      (error: any) => {
        errorCallback(error);
      }
    );
  }

  confirm(userId: number, salesStatusCode: String, salesManagerUserId: number, callback: () => void, errorCallback: (error: any) => void) {
    let url: string = "user/sales/status/confirm";

    return this.apiService.postInnerTargetApi(
      url,
      { userId: userId, salesStatusCode: salesStatusCode, salesManagerUserId: salesManagerUserId },
      (value: any) => {
        callback();
      },
      (error: any) => {
        errorCallback(error);
      }
    );
  }


  sendEmail(formData: any, callback?: () => void, error?: (error) => void) {
    return this.apiService.postInnerTargetApi(
      'user/sales/email',
      formData,
      (value) => {
        if (callback) {
          callback();
        }
      },
      (error) => {
        if (error) {
          error(error);
        }
      }
    );
  }



  getUserSalesStatusLog(userId: number, callback?: (values: UserSalesStatusLog[]) => void, errorCallback?: (error) => void) {
    let url: string = "user/sales/status/log/" + new String(userId);

    return this.apiService.getInnerTargetApi(
      url,
      null,
      (values: UserSalesStatusLog[]) => {
        if (!values) {
          return
        }

        if (callback) {
          let logs: UserSalesStatusLog[] = [];
          for (let value of values) {
            logs.push(new UserSalesStatusLog(value));
          }

          callback(logs);
        }
      },
      (error: any) => {
        if (errorCallback) {
          errorCallback(error);
        }
      }
    );

  }

}




export class GetUserParameter {
  page: number = 1;
  jobTp: String;
  stusCd: number;
  salesManagerUserId: number;
  lingoAuthStatusCd: number;
  text: string;

}

export class UserNameModel {
  userId: number;
  email: String;
  lastNm: String;
  firstNm: String;

  get fullName() {
    let _fullName = '';

    if (this.lastNm && this.lastNm.trim()) {
      _fullName += this.lastNm.trim();
    }

    if (this.firstNm && this.firstNm.trim()) {
      _fullName += this.firstNm;
    }

    return _fullName;
  }

  constructor(obj?: any) {
    if (!obj) {
      return;
    }

    this.userId = obj.userId;
    this.email = obj.email;
    this.lastNm = obj.lastNm;
    this.firstNm = obj.firstNm;
  }
}

export class SalesStatus {
  salesStatusCode: String;
  statusTitle: String;
  statusDesc: String;
  emailYn: String;
  emailTemplateId: number;

  constructor(obj?: any) {
    if (!obj) {
      return;
    }

    this.salesStatusCode = obj.salesStatusCode;
    this.statusTitle = obj.statusTitle;
    this.statusDesc = obj.statusDesc;
    this.emailYn = obj.emailYn;
    this.emailTemplateId = obj.emailTemplateId;

  }
}


export class PageModel<T> {
  pageNo: number;
  noOfElems: number;
  size: number;
  totalElems: number;
  totalPages: number;
  datas: T[] = [];

  constructor(obj?: any) {
    if (!obj) {
      return;
    }
    this.pageNo = obj.pageNo;
    this.noOfElems = obj.noOfElems;
    this.size = obj.size;
    this.totalElems = obj.totalElems;
    this.totalPages = obj.totalPages;
    this.datas = obj.datas;
  }
}


export class UserAuth {
  userAuthId: number;
  userId: number;
  authTypeCd: number;
  stusCd: number;
  authKey: string;
  corpRegFile: string;
  corpRegFileNm: string;
  corpRegNo: string;
  remark: string;

  constructor(obj?: any) {
    if (!obj) {
      return;
    }
    this.userAuthId = obj.userAuthId;
    this.userId = obj.userId;
    this.authTypeCd = obj.authTypeCd;
    this.stusCd = obj.stusCd;
    this.authKey = obj.authKey;
    this.corpRegFile = obj.corpRegFile;
    this.corpRegFileNm = obj.corpRegFileNm;
    this.corpRegNo = obj.corpRegNo;
    this.remark = obj.remark;
  }

}


export class UserForSalesManagement {
  userId: number;
  email: String;
  userTp: String;
  jobTp: String;
  jobTxt: String;
  lastNm: String;
  firstNm: String;
  address: String;
  zip: String;
  tel: String;
  mobile: String;
  fax: String;
  cntryCd: String;
  cmpnyNm: String;
  stusCd: number;
  regDt: Date;
  updDt: Date;

  cnsltnBookCnt: number;
  cnsltnRequestCnt: number;
  lingoAuthStatus: number;
  hasAuthShipgo: boolean;
  lastEmailSentDtm: Date;
  lastConfirmSalesStatusCode: String;
  hasMessage: boolean;
  sessionUserId: number;

  salesManager: UserNameModel;
  salesStatusDetail: SalesStatus;


  constructor(obj?: any) {
    if (!obj) {
      return;
    }

    this.userId = obj.userId;
    this.email = obj.email;
    this.userTp = obj.userTp;
    this.jobTp = obj.jobTp;
    this.jobTxt = obj.jobTxt;
    this.lastNm = obj.lastNm;
    this.firstNm = obj.firstNm;
    this.address = obj.address;
    this.zip = obj.zip;
    this.tel = obj.tel;
    this.mobile = obj.mobile;
    this.fax = obj.fax;
    this.cntryCd = obj.cntryCd;
    this.cmpnyNm = obj.cmpnyNm;
    this.stusCd = obj.stusCd;
    this.regDt = obj.regDt;
    this.updDt = obj.updDt;

    this.cnsltnBookCnt = obj.cnsltnBookCnt;
    this.cnsltnRequestCnt = obj.cnsltnRequestCnt;
    this.lingoAuthStatus = obj.lingoAuthStatus;
    this.hasAuthShipgo = obj.hasAuthShipgo;
    this.lastEmailSentDtm = obj.lastEmailSentDtm;
    this.lastConfirmSalesStatusCode = obj.lastConfirmSalesStatusCode;
    this.hasMessage = obj.hasMessage;
    this.sessionUserId = obj.sessionUserId;

    if (obj.salesManager) {
      this.salesManager = new SalesManager(obj.salesManager);
    }

    if (obj.salesStatusDetail) {
      this.salesStatusDetail = new SalesStatus(obj.salesStatusDetail);
    }
  }


  get fullName(): String {
    let fullName = null;

    if (this.lastNm) {
      fullName = this.lastNm;
    }

    if (this.firstNm) {
      fullName += this.firstNm;
    }

    return fullName;
  }

  get jobTpText(): String {
    return (this.jobTp === "0" ? "화주" : this.jobTp === "1" ? "포워더" : this.jobTp == "2" ? "선사" : "기타");
  }


  get lingoAuthStatusText(): String {
    if (this.lingoAuthStatus) {
      if (this.lingoAuthStatus === 1) {
        return "요청";
      }
      else if (this.lingoAuthStatus === 2) {
        return "요청 승인 완료";
      }
      else if (this.lingoAuthStatus === 3) {
        return "최종 승인 완료";
      }
      else if (this.lingoAuthStatus === 99) {
        return "거절";
      }
    }
    return null;
  }

  get stusText(): String {
    if (!this.stusCd) {
      return "상태코드 없음";
    } else if (this.stusCd === 1) {
      return "정상가입";
    } else if (this.stusCd === 2) {
      return "임시가입";
    } else if (this.stusCd === -1) {
      return "탈퇴";
    } else {
      return "기타";
    }
  }


  get cnsltnText(): String {
    let cnsltnText = String(Number(this.cnsltnBookCnt));
    cnsltnText += " / ";
    cnsltnText += String(Number(this.cnsltnRequestCnt));
    return cnsltnText;
  }


  get salesManagerName(): String {
    if (this.salesManager) {
      return this.salesManager.fullName;
    } else {
      return null;
    }
  }

  get lastEmailSentDtmLocal(): String {
    if (this.lastEmailSentDtm) {
      return moment(this.lastEmailSentDtm).format(DateTimeUtil.dateTimeFormat);
    } else {
      return null;
    }
  }

  get regDtLocalTime(): String {
    if (this.regDt) {
      return moment(this.regDt).local().format(DateTimeUtil.dateTimeFormat);
    } else {
      return null;
    }
  }


  get hasSendEmailButton(): boolean {
    if (
      this.salesManager
      && this.sessionUserId === this.salesManager.userId
      && this.salesStatusDetail
      && this.salesStatusDetail.emailYn == "Y") {
      return true;
    }
    return false;
  }


  get hasConfirmButton(): boolean {
    if (
      this.salesManager
      && this.sessionUserId === this.salesManager.userId
      && this.salesStatusDetail
      && this.salesStatusDetail.salesStatusCode !== this.lastConfirmSalesStatusCode
      && this.salesStatusDetail.salesStatusCode != "0") {
      return true;
    }

    return false;
  }


  get hasHistoryButton(): boolean {
    return true;
  }


  get hasCompleteButton(): boolean {
    if (
      this.salesManager
      && this.sessionUserId === this.salesManager.userId
      && this.salesStatusDetail
      && this.salesStatusDetail.salesStatusCode !== "0") {
      return true;
    }

    return false;
  }

  get hasInitButton(): boolean {
    if (this.salesManager
      && this.sessionUserId === this.salesManager.userId
      && this.salesStatusDetail
      && this.salesStatusDetail.salesStatusCode === "0") {
      return true;
    }

    return false;
  }

  get salesStatusText(): String {
    if (this.salesStatusDetail != null) {
      if (this.salesStatusDetail && this.salesStatusDetail.salesStatusCode === this.lastConfirmSalesStatusCode) {
        return "[TBN]";
      }
      else {
        let text: String = "[" + this.salesStatusDetail.salesStatusCode + "] " + this.salesStatusDetail.statusTitle;
        return text;
      }
    }

    return null;
  }

}



export class UserSalesMessage {
  public messageId: number;
  public userId: number;
  public insDtm: Date;
  public insUserId: number;
  public delYn: String;
  public delDtm: Date;
  public delUserId: number;
  public insUser: UserNameModel;
  public sessionUserId: number;

  public tempMessage: String;
  public message: String;

  public isEditing: boolean = false;

  public get insDtmLocal(): string {
    return Util.getDtmLocalStr(this.insDtm);
  }

  constructor(obj?: any) {
    if (!obj) {
      return;
    }

    this.messageId = obj.messageId;
    this.userId = obj.userId;
    this.message = obj.message;
    this.tempMessage = obj.message;
    this.insDtm = obj.insDtm;
    this.insUserId = obj.insUserId;
    this.delYn = obj.delYn;
    this.delDtm = obj.delDtm;
    this.delUserId = obj.delUserId;
    this.insUser = new UserNameModel(obj.insUser);
    this.sessionUserId = obj.sessionUserId;
  }

}


export class UserSalesStatusLog {
  public confirmLogId: number;
  public userId: number;
  public confirmDtm: Date;
  public get confirmDtmStr(): String {
    if (this.confirmDtm) {
      return moment(this.confirmDtm).format(DateTimeUtil.dateTimeFormat);
    } else {
      return null;
    }
  }

  public emailSendYn: String;
  public get emailSendYnStr(): String {
    if (this.emailSendYn === 'Y') {
      return '이메일 전송';
    } else {
      return '이메일 미 전송';
    }
  }

  public salesStatusCode: String;
  public statusTitle: String;
  public statusDesc: String;

  public confirmUserId: number;
  public confirmUserLastNm: String;
  public confirmUserFirstNm: String;
  public get confirmUserFullName(): String {
    let fullName: String = "";
    if (this.confirmUserLastNm) {
      fullName += this.confirmUserLastNm.trim();
    }
    if (this.confirmUserFirstNm) {
      fullName += this.confirmUserFirstNm.trim();
    }
    return fullName;
  }

  constructor(obj?: any) {
    this.confirmLogId = obj.confirmLogId;
    this.userId = obj.userId;
    this.confirmDtm = obj.confirmDtm;
    this.emailSendYn = obj.emailSendYn;

    this.salesStatusCode = obj.salesStatusCode;
    this.statusTitle = obj.statusTitle;
    this.statusDesc = obj.statusDesc;

    this.confirmUserId = obj.confirmUserId;
    this.confirmUserLastNm = obj.confirmUserLastNm;
    this.confirmUserFirstNm = obj.confirmUserFirstNm;

  }
}




// WEBPACK FOOTER //
// ./src/app/services/sales.service.ts